import React from 'react';
import type {MessageDescriptor} from 'react-intl';
import {DownloadCsvButton} from '@igp/shared/components/download';

import {usePlayerLevelReportV2Download} from '../hooks';
import type {PlayerLevelReportV2ViewModelKeys} from '../types';

export type PlayerLevelReportV2DownloadCsvButtonProps = {
    keys: PlayerLevelReportV2ViewModelKeys[];
    filter: string;
    filename: MessageDescriptor;
    total: number;
    mode: 'client' | 'server';
    disabled: boolean;
};

export function PlayerLevelReportV2DownloadCsvButton({
    disabled,
    filename,
    total,
    keys,
    filter,
    mode,
}: PlayerLevelReportV2DownloadCsvButtonProps) {
    const {handleDownload, isProgress} = usePlayerLevelReportV2Download({filename, total, keys, filter, mode});
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || disabled} />;
}
